import { render } from "./FilterModule_promemoria.vue?vue&type=template&id=35ef0c7c&scoped=true"
import script from "./FilterModule_promemoria.vue?vue&type=script&lang=js"
export * from "./FilterModule_promemoria.vue?vue&type=script&lang=js"

import "../../assets/css/staff-reminder-filters.css?vue&type=style&index=0&id=35ef0c7c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ef0c7c"]])

export default __exports__